export default __webpack_public_path__ + "static/media/pvn-arte-12.78c3ff3d.webp";